module.exports = __webpack_public_path__ + "static/tick-leaf-0fdf6e38ac9756fb9254b89ddff32de1.svg";